import { isServer } from 'src/libs/helper'
import { CompanyTranslator } from 'src/translators'
import { useGetCompanyQuery } from 'src/types/generated'

import { useCompanyStorage } from './useCompanyStorage'

export const useGetCompany = () => {
  const { loading, data, error, refetch } = useGetCompanyQuery()
  const { saveCompanyToLocalStorage, removeCompanyFromLocalStorage } = useCompanyStorage()

  const company = data && data.company ? CompanyTranslator.toEntity(data.company) : undefined
  if (!isServer) {
    // GAで使用するためローカルストレージにも値を保存する
    company ? saveCompanyToLocalStorage(company) : removeCompanyFromLocalStorage()
  }

  return { loading, company, error, refetch }
}
